import script from "./geoDataSecurityCheck.vue?vue&type=script&setup=true&lang=js"
export * from "./geoDataSecurityCheck.vue?vue&type=script&setup=true&lang=js"

import "./geoDataSecurityCheck.vue?vue&type=style&index=0&id=8193791a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8193791a"]])

export default __exports__